module.exports = __webpack_public_path__ + "img/liquid_pipe.f023dca4.svg";